import React from 'react'
import classnames from 'classnames'
import { observer } from 'mobx-react'

const MapInstruction = ({ children, extraClasses = [] }) => (
  <div className={classnames('map-instruction', extraClasses)}>
    <svg
      className='map-instruction__icon'
      width='18'
      height='18'
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth='1.8'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <polygon points='3 3 10 21 13 13 21 10 3 3' />
    </svg>
    <span className='map-instruction__text'>{children}</span>
  </div>
)

export default observer(MapInstruction)
